import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { ReactComponent as SvgDotPatternIcon } from "../../images/dot-pattern.svg";
import { SectionHeading as HeadingTitle } from "../misc/Headings.js";

const Container = tw.div`relative`;

const SingleColumn = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const HeadingInfoContainer = tw.div`flex flex-col items-center`;
const HeadingDescription = tw.p`mt-4 font-medium text-gray-600 text-center max-w-sm`;

const Content = tw.div`mt-16`;

const Card = styled.div(props => [
  tw`mt-24 md:flex justify-center items-center`,
  props.reversed ? tw`flex-row-reverse` : "flex-row"
]);
const Image = styled.div(props => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded md:w-1/2 lg:w-5/12 xl:w-1/3 flex-shrink-0 h-80 md:h-144 bg-cover bg-center mx-4 sm:mx-8 md:mx-4 lg:mx-8`
]);
const Details = tw.div`mt-4 md:mt-0 md:max-w-md mx-4 sm:mx-8 md:mx-4 lg:mx-8`;
const Subtitle = tw.div`font-bold tracking-wide text-secondary-100`;
const Title = tw.h4`text-3xl font-bold text-gray-900`;
const Description = tw.p`mt-2 text-base leading-loose`;
const Link = tw.a`inline-block mt-4 text-sm text-pbsGreen-500 font-bold cursor-pointer transition duration-300 border-b-2 border-transparent hover:border-pbsGreen-500`;

const SvgDotPattern1 = tw(
  SvgDotPatternIcon
)`absolute top-0 left-0 transform -translate-x-20 rotate-90 translate-y-8 -z-10 opacity-25 text-pbsGreen-500 fill-current w-24`;
const SvgDotPattern2 = tw(
  SvgDotPatternIcon
)`absolute top-0 right-0 transform translate-x-20 rotate-45 translate-y-24 -z-10 opacity-25 text-pbsGreen-500 fill-current w-24`;
const SvgDotPattern3 = tw(
  SvgDotPatternIcon
)`absolute bottom-0 left-0 transform -translate-x-20 rotate-45 -translate-y-8 -z-10 opacity-25 text-pbsGreen-500 fill-current w-24`;
const SvgDotPattern4 = tw(
  SvgDotPatternIcon
)`absolute bottom-0 right-0 transform translate-x-20 rotate-90 -translate-y-24 -z-10 opacity-25 text-pbsGreen-500 fill-current w-24`;

export default function VerticalWithAlternateImageAndTextServices () {
  const cards = [
    {
      imageSrc:
        "https://images.unsplash.com/photo-1676151863834-b9b162faa8ab?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      subtitle: "Paid",
      title: "Payroll Outsourcing",
      description:
        "We provide flexible payroll services—whether weekly, fortnightly, or monthly—ensuring timely processing, accurate payslips, inclusion of all payroll costs (overtime, holiday pay, bonuses, commissions, pension deductions, etc.), preparation of relevant reports (SO1, SO2, P24, P45), and reconciliation of all tax-related liabilities.",
      url: "https://timerse.com"
    },
    {
      imageSrc:
        "https://images.pexels.com/photos/9487227/pexels-photo-9487227.jpeg",
      subtitle: "Free",
      title: "Employee Management",
      description:
        "Businesses can outsource their human resources—whether for the entire organization or specific staff categories—to us for greater efficiency. We handle all functions related to hiring, dismissals, staff discipline, and benefit administration.",
      url: "https://timerse.com"
    },
    {
      imageSrc:
        "https://images.unsplash.com/photo-1747056711958-9d8c3b97b578?q=80&w=690&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      subtitle: "Exclusive",
      title: "HR Outsourcing Contract Staff",
      description:
        "We provide personnel for large staffing needs in manufacturing or industrial operations for short, medium, or long-term placements, with employees contracted directly to us, relieving clients of all administrative responsibilities during their placement.",
      url: "https://timerse.com"
    },
    {
      imageSrc:
        "https://cdn.prod.website-files.com/6491ed06a1dba31dfb53d133/653179470dff3ee0bb0fc9c6_What%20is%20Temporary%20Staffing.png",
      subtitle: "Free",
      title: "Temporary Staff (Placement)",
      description:
        "We specialize in providing short-term coverage for critical positions or business cycle gaps, leveraging our network of resources to supply high-quality staff at short notice to cover for team members on leave.",
      url: "https://timerse.com"
    },
    {
      imageSrc:
        "https://images.unsplash.com/photo-1487528278747-ba99ed528ebc?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      subtitle: "Exclusive",
      title: "Recruitment",
      description:
        "Founded on the belief that people are the heart of every successful business, we connect top talent with leading organizations by leveraging years of industry expertise to understand the unique needs of both employers and candidates, focusing beyond resumes on culture fit, long-term potential, and career goals to ensure lasting success for all parties.",
      url: "https://timerse.com"
    }
  ];

  return (
    <Container>
      <SingleColumn>
        <HeadingInfoContainer>
          <HeadingTitle>Services Offered</HeadingTitle>
          {/* <HeadingDescription>
            Here are some of the most popular events in New York City curated by professionals.
          </HeadingDescription> */}
        </HeadingInfoContainer>

        <Content>
          {cards.map((card, i) => (
            <Card key={i} reversed={i % 2 === 1}>
              <Image imageSrc={card.imageSrc} />
              <Details>
                {/* <Subtitle>{card.subtitle}</Subtitle> */}
                <Title>{card.title}</Title>
                <Description>{card.description}</Description>
                {/* <Link href={card.url}>See Event Details</Link> */}
              </Details>
            </Card>
          ))}
        </Content>
      </SingleColumn>
      <SvgDotPattern1 />
      <SvgDotPattern2 />
      <SvgDotPattern3 />
      <SvgDotPattern4 />
    </Container>
  );
};
